import { render, staticRenderFns } from "./ChartSalesAnalysis.vue?vue&type=template&id=66baf2e7"
import script from "./ChartSalesAnalysis.vue?vue&type=script&lang=js"
export * from "./ChartSalesAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports